import { render, staticRenderFns } from "./KgjtWebsiteProductInfo.vue?vue&type=template&id=47b32113&scoped=true&"
import script from "./KgjtWebsiteProductInfo.vue?vue&type=script&lang=js&"
export * from "./KgjtWebsiteProductInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b32113",
  null
  
)

export default component.exports